export default "__VITE_ASSET___eNtx6Ea__"